import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Dayjs } from "dayjs";

interface PropTypes {
    courseTitle: string;
    courseSectionTitle: string;
    selectedDate: Dayjs;
    numOpenings: number;
    loading: boolean;
}

function PeriodListHeader({ courseTitle, courseSectionTitle, selectedDate, numOpenings, loading }: PropTypes) {
    const theme = useTheme();

    const getBadgeColor = () => {
        if (numOpenings <= 0) {
            return theme.palette.error.main;
        }
        return theme.palette.success.main;
    }

    return (
        <Box
            display={'flex'}
            flexDirection={{ xs: 'column', sm: 'row' }}
            flex={'1 1 100%'}
            justifyContent={{ sm: 'space-between' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            marginBottom={4}
        >
            <Box marginBottom={{ xs: 1, sm: 0 }}>
                <Box marginBottom={2}>
                    <Typography variant={'h5'} fontWeight={700}>
                        {courseTitle}
                    </Typography>
                    <Typography variant={'subtitle2'} color={'text.secondary'} gutterBottom>
                        {courseSectionTitle}
                    </Typography>
                </Box>
                <Typography color={'text.secondary'}>
                    {selectedDate.format('dddd, MMMM Do, YYYY')}
                </Typography>
            </Box>
            <Box
                paddingY={1 / 2}
                paddingX={1}
                bgcolor={!loading ? getBadgeColor() : undefined}
                borderRadius={2}
                marginRight={1}
            >
                {loading && (
                    <Skeleton variant='rectangular'>
                        <Typography variant={'subtitle1'} fontWeight={700}>0 Openings</Typography>
                    </Skeleton>
                )}
                {!loading && (
                    <Typography
                        variant={'subtitle1'}
                        fontWeight={700}
                        sx={{ color: 'common.black' }}
                    >
                        {(numOpenings == 0 || numOpenings > 1) && `${numOpenings} Openings`}
                        {numOpenings == 1 && "1 Opening"}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}

export default PeriodListHeader;